import React, { Component } from "react";

import Joi from "joi-browser";
import Input from "./Input";
import Select from "./NewSelect";
import File from "./File";
import Img from "./InputImg";

import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";
import Checkbox from "./Checkbox";

class Form extends Component {
  static contextType = PopUpContext;

  state = {
    data: {},
    errors: {},
    requestSended: false,
  };

  validate = () => {
    const options = { abortEarly: false };

    const { error } = Joi.validate(this.state.data, this.schema, options);

    if (!error) return null;

    const errors = {};

    for (let item of error.details) errors[item.path[0]] = item.message;

    return errors;
  };

  validateProperty = ({ name, value }) => {
    const obj = { [name]: value };

    const schema = { [name]: this.schema[name] };

    const { error } = Joi.validate(obj, schema);

    return error ? error.details[0].message : null;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const errors = this.validate();

    this.setState({ errors: errors || {} });

    if (errors) return;

    this.setState({ requestSended: true });

    this.doSubmit(e);
  };

  handleChange = ({ currentTarget: input }) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(input);

    if (errorMessage) {
      errors[input.name] = errorMessage;
    } else {
      delete errors[input.name];
    }

    const data = { ...this.state.data };

    data[input.name] = input.value;

    this.setState({ data, errors });
  };

  handleCheckBox = ({ currentTarget: input }) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(input);

    if (errorMessage) {
      errors[input.name] = errorMessage;
    } else {
      delete errors[input.name];
    }

    const data = { ...this.state.data };

    data[input.name] = input.checked ? 1 : 0;

    this.setState({ data, errors });
  };

  getValue = (e) => {
    const data = { ...this.state.data };

    data[e.name] = e.data.id;

    this.setState({ data });
  };

  renderButton(label) {
    const { requestSended } = this.state;
    const { togglePopUp } = this.context;

    return (
      <React.Fragment>
        <button disabled={requestSended}>{label}</button>
        <button type="button" onClick={() => togglePopUp()}>
          {lbl.Cancel}
        </button>
      </React.Fragment>
    );
  }

  renderInput(name, label, type = "text") {
    const { data, errors } = this.state;
    // Email/phone/URL (and English-name fields) must stay LTR inside RTL forms,
    // otherwise @/domain reverse and the caret jumps to the wrong end.
    const ltrTypes = ["email", "tel", "url", "number", "password"];
    const ltrName = /(email|phone|link|_en$|password|otp)/i.test(name || "");
    const dirLtr = ltrTypes.includes(type) || ltrName;
    return (
      <div className="input">
        <label htmlFor={name}>{label}</label>
        <Input
          type={type}
          name={name}
          value={data[name]}
          onChange={this.handleChange}
          error={errors[name]}
          {...(dirLtr ? { dir: "ltr" } : {})}
        />
      </div>
    );
  }

  renderCheckBox(name, label, text) {
    const { data, errors } = this.state;

    return (
      <div className="input checkbox">
        <label htmlFor={name}>{label}</label>
        <Checkbox
          name={name}
          value={data[name]}
          onClick={this.handleCheckBox}
          error={errors[name]}
          text={text}
        />
      </div>
    );
  }

  renderSelect(name, label, options, disabled, callBack) {
    const { data, errors } = this.state;

    return (
      <div className="select">
        <label htmlFor={name}>{label}</label>
        <Select
          name={name}
          label={label}
          options={options}
          value={data[name]}
          error={errors[name]}
          passValue={(e) => {
            this.getValue(e);
            if (callBack) callBack(e);
          }}
          disabled={disabled}
        />
      </div>
    );
  }

  renderFile(name, label) {
    const { errors } = this.state;
    return (
      <div className="file">
        <label htmlFor={name}>{label}</label>
        <File
          name={name}
          label={label}
          error={errors[name]}
          onChange={this.handleChange}
        />
      </div>
    );
  }

  renderImg(name, src) {
    return <Img name={name} src={src} />;
  }

  cleanObject = (obj) => {
    Object.keys(obj).forEach((key) => {
      if (obj[key] === null || obj[key] === undefined) {
        delete obj[key];
      }
    });

    console.log(obj);

    return obj;
  };
}

export default Form;
